// AUTO-GENERATED by scripts/generate-glossary-data.js - do not edit by hand.
// slug -> display title for every /compare/ page, so glossary entries can
// link to them without importing the full comparison corpus.
export const COMPARISON_TITLES = {
  "hazel-alternative-mac": "Hazel Alternatives for Mac",
  "sparkle-vs-sortio": "Sparkle vs Sortio",
  "filejuggler-vs-sortio": "FileJuggler vs Sortio",
  "filect-vs-sortio": "Filect vs Sortio",
  "filesmagic-ai-vs-sortio": "FilesMagic AI vs Sortio",
  "zush-vs-sortio": "Zush vs Sortio",
  "mac-file-manager-alternative": "Mac File Manager Alternative",
  "belvedere-alternative": "Belvedere Alternative",
  "cleanmymac-alternative-file-organization": "CleanMyMac Alternative for File Organization",
  "devonthink-alternative": "DEVONthink Alternative",
  "dropit-alternative": "DropIt Alternative",
  "floxtop-alternative": "Floxtop Alternative",
  "folder-tidy-alternative": "Folder Tidy Alternative",
  "gemini-2-alternative": "Gemini 2 Alternative",
  "hazel-alternative-linux": "Hazel Alternative for Linux",
  "namequick-alternative": "NameQuick Alternative",
  "paperless-ngx-alternative": "Paperless-ngx Alternative",
  "spotless-alternative": "Spotless Alternative",
  "file-juggler-vs-hazel": "File Juggler vs Hazel",
  "dropzone-vs-hazel": "Dropzone vs Hazel",
  "dropzone-alternative": "Dropzone Alternative",
  "belvedere-alternative-windows": "Belvedere Alternative for Windows",
  "organize-my-files-alternative": "Organize My Files Alternative",
  "easy-file-organizer-alternative": "Easy File Organizer Alternative",
  "file-organizer-pro-alternative": "File Organizer Pro Alternative",
  "tidy-up-alternative-mac": "Tidy Up Alternative for Mac",
  "filebot-alternative": "FileBot Alternative",
  "spacedrive-alternative": "Spacedrive Alternative",
  "ai-file-sorter-alternative": "AI File Sorter Alternative",
  "sortio-vs-easy-file-organizer": "Sortio vs Easy File Organizer",
  "sortio-vs-dropit": "Sortio vs DropIt",
  "sortio-vs-dropzone": "Sortio vs Dropzone",
  "sortio-vs-tidy-up": "Sortio vs Tidy Up",
  "sortio-vs-organize-my-files": "Sortio vs Organize My Files",
  "hazel-vs-easy-file-organizer": "Hazel vs Easy File Organizer",
  "file-juggler-vs-dropit": "File Juggler vs DropIt",
  "dropit-vs-belvedere": "DropIt vs Belvedere",
  "easy-file-organizer-vs-file-juggler": "Easy File Organizer vs File Juggler",
  "total-commander-alternative": "Total Commander Alternative",
  "digital-janitor-alternative": "Digital Janitor Alternative",
  "hazel-vs-keyboard-maestro": "Hazel vs Keyboard Maestro",
  "total-commander-vs-directory-opus": "Total Commander vs Directory Opus",
  "hazel-vs-tidy-up": "Hazel vs Tidy Up",
  "directory-opus-alternative": "Directory Opus Alternative",
  "forklift-alternative-mac": "ForkLift Alternative for Mac"
};

export const isComparisonSlug = (slug) =>
  Object.prototype.hasOwnProperty.call(COMPARISON_TITLES, slug);
